"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PDP_OVERRIDE_DISCLOSURES_CONFIG = exports.PDP_OVERRIDE_DISCLOSURES_CONFIG = {
  be: {
    per: {
      pdpCardQualityBreakdown: "pdpCardBondQualityBreakdownBelgium",
      pdpCardFees: "pdpCardFeesBelgium",
      pdpCardFundFacts: "pdpCardFundFactsBelgium",
      pdpCardPerformanceLargeText: "pdpCardPerformanceLargeTextBelgium",
      pdpCardPerformance: "pdpCardPerformanceBelgium",
      pdpCardRiskIndicator: "pdpCardRiskIndicatorBelgium"
    },
    adv: {
      pdpCardQualityBreakdown: "pdpCardBondQualityBreakdownBelgium",
      pdpCardFees: "pdpCardFeesBelgium",
      pdpCardFundFacts: "pdpCardFundFactsBelgium",
      pdpCardPerformanceLargeText: "pdpCardPerformanceLargeTextBelgium",
      pdpCardPerformance: "pdpCardPerformanceBelgium",
      pdpCardRiskIndicator: "pdpCardRiskIndicatorBelgium"
    }
  }
};